export default class Feature {
    value;
    constructor(id, lat, lng, rotation) {
        this.value = {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [
                    lng, lat
                ]
            },
            'properties': {
                'id': id,
                "rotation": rotation
            }
        };
    }
    getValue() {
        return this.value;
    }
}
